import "../styles/Info.scss";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import parse from "html-react-parser";

function XLive(props) {
  const { t } = props;

  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <div className="info-mirror">
              <div className="info-part">
                <div className="info-head">{t("info.xlive.head")}</div>
                <div className="info-text">{parse(t("info.xlive.descr"))}</div>
                <div className="info-title">{t("info.xlive.will.title")}</div>
                <div className="info-text">{parse(t("info.xlive.will.text"))}</div>
                <div className="info-title">{t("info.xlive.how.title")}</div>
                <div className="info-text">{parse(t("info.xlive.how.text"))}</div>
                <div className="info-text">{parse(t("info.xlive.remind.text"))}</div>
                {/* <div className="info-text">{parse(t("info.xlive.remind.text.store"))}</div> */}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default XLive;
